import { render } from "./AnimationText.vue?vue&type=template&id=4be252c8&scoped=true"
import script from "./AnimationText.vue?vue&type=script&lang=js"
export * from "./AnimationText.vue?vue&type=script&lang=js"

import "./AnimationText.vue?vue&type=style&index=0&id=4be252c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be252c8"]])

export default __exports__